import {ValueObject} from '@s-ui/domain'

export class UpdatePasswordUserRequest extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.newPassword
   * @param {String} data.password
   **/

  static validate({newPassword, password, userNotLoggedInUserError}) {
    const checkParamExists = param => param !== undefined && param !== null

    const areInvalidData = [(newPassword, password)].some(param => !checkParamExists(param))
    if (areInvalidData) {
      throw userNotLoggedInUserError('All params are mandatory to update user password')
    }
  }
}
